// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bjKj","right":"styles_right__DSDWr"};